// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrivacyPolicyPage-m_FoMBxZm6GZphWnypUptR ul {
  margin-bottom: 1rem;
  list-style-type: disc;
  list-style-position: outside;
  margin-left: 1rem;
}

.PrivacyPolicyPage-m_FoMBxZm6GZphWnypUptR ul li {
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./client/shared/PrivacyPolicyPage/PrivacyPolicyPage.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".privacyPolicy ul {\n  margin-bottom: 1rem;\n  list-style-type: disc;\n  list-style-position: outside;\n  margin-left: 1rem;\n}\n\n.privacyPolicy ul li {\n  margin-bottom: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
export var privacyPolicy = `PrivacyPolicyPage-m_FoMBxZm6GZphWnypUptR`;
export default ___CSS_LOADER_EXPORT___;
